import './assets/main.css'
import 'vfonts/Lato.css'
// import 'vfonts/Inter.css'
import 'vfonts/FiraCode.css'
import 'v-calendar/style.css'
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { initSentry } from './config/sentry'
import dates from './plugins/dates'
import App from './App.vue'
import CommandApp from './CommandApp.vue'
import router from './router'
import ToolbarComponent from './components/ToolbarComponent.vue'
import ShopsTableComponent from './components/ShopsTableComponent.vue'
import DatePickerComponent from './components/DatePickerComponent.vue'
import ImporterHistoryComponent from './components/ImporterHistoryComponent.vue'
import ImportStateComponent from './components/ImportStateComponent.vue'
import GroupStatusModalComponent from './components/GroupStatusModalComponent.vue'
import ImporterComponent from './components/ImporterComponent.vue'
import NavLinkComponent from './components/NavLinkComponent.vue'
import CustomSwitchComponent from './components/CustomSwitchComponent.vue'

const app = createApp(App)
const commandApp = createApp(CommandApp)

initSentry(app, router)

app.component('cdi-toolbar', ToolbarComponent)
app.component('cdi-shops-table', ShopsTableComponent)
app.component('cdi-date-picker', DatePickerComponent)
app.component('cdi-importer-history', ImporterHistoryComponent)
app.component('cdi-import-state', ImportStateComponent)
app.component('cdi-group-status', GroupStatusModalComponent)
app.component('cdi-importer', ImporterComponent)
app.component('nav-link', NavLinkComponent)
app.component('c-switch', CustomSwitchComponent)

app.directive('focus', {
  mounted(el) {
    const input = el.querySelector('.n-input__input-el')
    input?.focus()
  }
})

app.use(createPinia())
app.use(router)
app.use(dates, { locale: 'da-DK' })

commandApp.use(router)

router.isReady().then(() => {
  if (router.currentRoute.value.path.startsWith('/cmd')) {
    commandApp.mount('#app')
  }

  else {
    app.mount('#app')
  }
})
